export default "__VITE_ASSET__Cg5clCLq__"